<script lang="ts" setup>
// import { theme } from '@/config/theme';
</script>

<template>
  <div class="loading-view">
    <div class="logo-row">
<!--      <component :is="theme.logo"/>-->
    </div>
  </div>
</template>

